import { jsx as c } from "react/jsx-runtime";
import { h as t } from "../../vendor-CPVnY93G.js";
import { c as s } from "../../styles.module-C5RaAp_v.js";
function i() {
  return /* @__PURE__ */ c(
    t,
    {
      className: s.colorThumb,
      style: ({ isDragging: e, defaultStyle: { transform: o, transition: a, ...r } }) => ({
        ...r,
        transform: `${o} ${e ? "scale(1.25)" : ""}`
      })
    }
  );
}
export {
  i as ColorThumb
};
